import { TOptions } from 'i18next'
import { FormatXMLElementFn, PrimitiveType } from 'intl-messageformat'
import { TIME_LABELS, TimeType, TimeTypeState } from './constants'

export const createTimeTypeOptionsForSelect = (
  tICU: (
    assetKey: string,
    values: Record<string, PrimitiveType | FormatXMLElementFn<string>>,
    options?: TOptions,
  ) => any,
  selectedTimeValue: number,
  allowedOptions?: TimeType[],
): { id: string; caption: string }[] =>
  (allowedOptions ?? Object.values(TimeType)).map(value => ({
    id: value,
    caption: tICU(TIME_LABELS[value], {
      count: selectedTimeValue,
    }),
  }))

export const convertSeconds = (seconds: number, outputType: TimeType): number => {
  switch (outputType) {
    case TimeType.MINUTES:
      return seconds / 60
    case TimeType.HOURS:
      return seconds / 3600
    case TimeType.DAYS:
      return seconds / 86400
    default:
      return seconds
  }
}

export const convertToSeconds = (value: number, inputType: TimeType): number => {
  switch (inputType) {
    case TimeType.MINUTES:
      return value * 60
    case TimeType.HOURS:
      return value * 3600
    case TimeType.DAYS:
      return value * 86400
    default:
      return value
  }
}

export const convertTimeValueToSeconds = (
  timeValue: number,
  timeType: TimeType,
  timeTypeState?: TimeTypeState,
): number => {
  const timeValueWithSign = timeTypeState === TimeTypeState.before ? timeValue * -1 : timeValue

  return convertToSeconds(timeValueWithSign, timeType)
}

export const convertSecondsToTimeValue = (
  seconds: number,
): {
  timeValue: number
  timeType: TimeType
  beforeAfter: TimeTypeState
  name: string
} => {
  const BEFORE_AFTER = seconds < 0 ? TimeTypeState.before : TimeTypeState.after
  const absoluteSeconds = Math.abs(seconds)

  const DAYS_SECONDS_COEFFICIENT = 60 * 60 * 24
  const HOURS_SECONDS_COEFFICIENT = 60 * 60
  const MINUTES_SECONDS_COEFFICIENT = 60

  if (!(absoluteSeconds % DAYS_SECONDS_COEFFICIENT) && absoluteSeconds / DAYS_SECONDS_COEFFICIENT)
    return {
      timeValue: Math.round(absoluteSeconds / DAYS_SECONDS_COEFFICIENT),
      timeType: TimeType.DAYS,
      beforeAfter: BEFORE_AFTER,
      name: 'global.name_of_times.days.plural',
    }
  else if (
    !(absoluteSeconds % HOURS_SECONDS_COEFFICIENT) &&
    absoluteSeconds / HOURS_SECONDS_COEFFICIENT
  ) {
    return {
      timeValue: Math.round(absoluteSeconds / HOURS_SECONDS_COEFFICIENT),
      timeType: TimeType.HOURS,
      beforeAfter: BEFORE_AFTER,
      name: 'global.name_of_times.hours.plural',
    }
  } else {
    return {
      timeValue: Math.round(absoluteSeconds / MINUTES_SECONDS_COEFFICIENT),
      timeType: TimeType.MINUTES,
      beforeAfter: BEFORE_AFTER,
      name: 'global.name_of_times.minutes.plural',
    }
  }
}
